import { IncomingMessage } from 'http';

import { Cart } from '../../../types/cart';
import { fechFromBPartsApi } from '../utils';

const fetchCart = async (
  {
    locale,
    is_advanced_view = false,
    detailed_prices = false,
  }: { locale: string; is_advanced_view?: boolean; detailed_prices?: boolean },
  req?: IncomingMessage
): Promise<Cart | Partial<Cart>> => {
  const url = `/${locale}/shop/carts/cart${
    is_advanced_view ? '?is_advanced_view=true' : ''
  }${
    detailed_prices === true
      ? `${is_advanced_view ? '&' : '?'}detailed_prices=true`
      : ''
  }`;

  const data = await fechFromBPartsApi(url, {
    credentials: 'include',
    headers: req ? new Headers(req.headers as HeadersInit) : undefined,
  });

  if (data.status === 404) {
    return {
      pk: 0,
      products: [],
      can_checkout: false,
      amount_display: '0',
      allowed_payment_methods: [],
      currency: '',
      estimated_date_arrival: '',
    };
  } else {
    return data.json();
  }
};

export default fetchCart;
